<template >
  <div class="container-fluid" v-if="department">
      <h4 class="mb-4">{{department.name}} (ЗАН)</h4>
      <div class="row justify-content-between">
      <div class="col">
        <div class="card shadow mb-4">
          <div class="card-header py-3">
            <div class="row">
              <div class="col col-expand">
                <h6 class="m-0 font-weight-bold text-primary">Багш нарын жагсаалт</h6>
              </div>
              <div class="col col-auto">
                <button
                  type="button"
                  class="btn btn-primary btn-sm btn-grey"
                  @click="$router.push({name:'TeacherAdd', params:{ teacherId:'new', schoolId: schoolId }})"
                >Багш нэмэx</button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div
              class="table-responsive"
              v-if="teachersOfSector!=null && teachersOfSector.length>0"
            >
              <table
                class="table table-sm table-bordered"
                id="dataTable"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Овог/Нэр</th>
                    <th>Багшийн код</th>
                    <th>Албан тушаал</th>
                    <th>имэйл</th>
                    <th v-if="!showSimple">төлөв</th>
                    <th>Үйлдэл</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(teacher, index) in teachersOfSector" v-bind:key="teacher.id">
                    <td>{{index+1}}</td>
                    <td>
                      <span
                        v-if="teacher.lastname && teacher.lastname.length>0"
                      >{{teacher.lastname[0]}}.</span>
                      {{teacher.name}}
                    </td>

                    <td>{{teacher.code}}</td>
                    <td>
                      <div>
                        <span v-if="teacher.positionData">{{teacher.positionData.name}}</span>
                      </div>
                    </td>

                    <td>{{teacher.email}}</td>
                    <td v-if="!showSimple">
                      <span
                        v-if="teacher.user==null || teacher.user==undefined"
                        class="badge notinsystem"
                      >Системд холбогдоогүй</span>
                      <span v-else class="badge badge-success">Системд холбогдсон</span>
                    </td>
                    <td>
                      <!-- <button class="btn btn-success">харах</button> -->
                      <button
                        class="btn btn-success btn-sm mr-2"
                        @click="$router.push({ name:'TeacherLessons', params:{schoolId:schoolId, teacherPath: 'schools/'+schoolId+'/teachers/'+teacher.id} })"
                      >хичээл</button>
                      <button class="btn btn-warning btn-sm" @click="_edit(teacher)">засах</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card shadow mb-4">
          <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">Албан тушаал</h6>
          </div>
          <div class="card-body" v-if="pros!=null && pros.length>0">
            <div class="table-responsive">
              <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Нэр</th>
                    <th>Үйлдэл</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(p, index) in pros" v-bind:key="p.id">
                    <td>{{index+1}}</td>
                    <td>{{p.name}}</td>

                    <td>
                      <!-- <button class="btn btn-info btn-sm mr-2" @click="$router.push({ name: 'SProgramLessons', params:{ schoolId: schoolId, programId: p.id , departmentId: departmentId} })">хичээлүүд</button> -->
                      <button class="btn btn-warning btn-sm mr-2" @click="_editProgram(p)">засах</button>

                      <!-- <button class="btn btn-outline-primary btn-sm" @click="$router.push({ name: 'IGroupStudents', params: { schoolId: schoolId, departmentId: departmentId, programId: p.id} })">сурагчид</button> -->
                      <!-- <button class="btn btn-danger" @click="_deleteProgram(p)">устгах</button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else class="alert alert-warning text-center">Одоогоор ороогүй байна.</div>
          <div class="card-footer">
            <div class="row justify-content-end">
              <div>
                <button type="button" class="d-flex btn btn-outline-default my-3" @click="_addProgram">
                  Албан тушаал нэмэх
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="proModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="proModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="proModalLabel">Албан нэмэх</h5>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Нэр</label>

                <input
                  v-model.trim="pro.name"
                  class="form-control"
                  id="exampleInputEmail"
                  aria-describedby="emailHelp"
                  placeholder="нэр оруулна уу"
                >
              </div>

              <!-- <div class="form-group">
                  <label>Бүлэгийн индекс</label>
                  <input v-model.trim="pro.hindex" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Хөтөлбөрийн индекс оруулна уу">
              </div>-->
              <div class="form-group">
                <label>Дэлгэрэнгүй</label>
                <textarea
                  rows="5"
                  v-model.trim="pro.description"
                  class="form-control"
                  placeholder="Дэлгэрэнгүй оруулна уу"
                />
              </div>
              <!-- <div class="form-group">
                   <label>Хөтөлбөрийн багийн ахлагч</label>
                  <input v-model.trim="pro.teamLeader" class="form-control" placeholder="Бүлэгийн багийн ахлагч оруулна уу">
                </div>
                <div class="form-group">
                  <label>Холбоо барих утас</label>
                  <input v-model.trim="pro.phone" class="form-control" placeholder="Холбоо барих утас оруулна уу">
                </div>
                <div class="form-group">
                  <label>Имэйл хаяг</label>
                  <input v-model.trim="pro.email" class="form-control" placeholder="Имэйл хаяг оруулна уу">
              </div>-->

              <hr>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
            <button
              @click="saveTopic"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >Xадгалаx</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "LessonDetail",
  data() {
    return {
      showSimple:false,
      department: null,
      pro: {
        name: null,
        description: null
      },
      pros: [],
      groups: ["А", "Б", "В", "Г", "Д", "Е", "Ё", "Ж", "З", "И"],
      teachers: [],
      categories: [],
      teachersOfSector: [],
      school: null
    };
  },
  methods: {
    _edit(teacher) {
      this.$router.push({
        name: "TeacherAdd",
        params: { teacherId: teacher.id }
      });
    },
    async _getTeacher() {
      var query = fb.db.collection("schools/" + this.schoolId + "/teachers");
      // if(this.program && this.program.ref){
      //   query=query.where("program", "==", this.program.ref);
      //   query=query.orderBy("name");
      // }

      if (query != null) {
        var documentSnapshots = await query.get();
        documentSnapshots.forEach(doc => {
          let object = doc.data();
          object.id = doc.id;
          console.log(object);
          this.teachersOfSector.push(object);
        });
      }
    },
    async _getData() {
      var schoolDoc = await fb.db.doc("schools/" + this.schoolId).get();
      if (schoolDoc.exists) {
        let school = schoolDoc.data();
        school.id = schoolDoc.id;
        school.ref = schoolDoc.ref;
        this.school = school;
      }
      fb.db
        .collection("schools/" + this.schoolId + "/sectors/")
        .doc(this.sectorId)
        .get()
        .then(doc => {
          let department = doc.data();
          department.id = doc.id;
          this.department = department;
        });

      fb.db
        .collection(
          "schools/" +
            this.schoolId +
            "/sectors/" +
            this.sectorId +
            "/positions"
        )
        .orderBy("name", "asc")
        .onSnapshot(querySnapshot => {
          this.pros = [];
          querySnapshot.forEach(doc => {
            let object = doc.data();
            object.id = doc.id;

            this.pros.push(object);
          });
        });
      this._getTeacher();
    },

    saveTopic() {
      if (
        this.pro != null &&
        this.pro != null &&
        this.pro.name != "" &&
        this.pro.description != ""
      ) {
        if (this.pro.id != null && this.pro.id != "") {
          fb.db
            .collection("schools")
            .doc(this.schoolId)
            .collection("sectors")
            .doc(this.sectorId)
            .collection("positions")
            .doc(this.pro.id)
            .update({
              name: this.pro.name,
              description: this.pro.description ? this.pro.description : null,
              modifiedAt: new Date(),
              modifiedUser: fb.usersCollection.doc(
                this.$store.getters.currentUser.uid
              )
            });
        } else {
          this.pro.createdAt = new Date();
          fb.db
            .collection("schools")
            .doc(this.schoolId)
            .collection("sectors")
            .doc(this.sectorId)
            .collection("positions")
            .doc()
            .set(this.pro);
          fb.db
            .collection("schools")
            .doc(this.schoolId)
            .collection("sectors")
            .doc(this.sectorId)
            .update({
              numberOfPrograms: fb.firestore.FieldValue.increment(1)
            });
        }
        this.pro = {
          name: null,
          description: null
        };
      }
    },

    goStat(type, topic) {
      this.$router.push({
        name: "TopicStat",
        params: { schoolId: this.schoolId, type: type.id, topicId: topic.id }
      });
    },
    _addProgram() {
      this.pro = {};
      $("#proModal").modal("toggle");
    },
    _editProgram(pro) {
      this.pro = Object.assign({}, pro);
      $("#proModal").modal("toggle");
    },
    _deleteProgram(pro) {
      var result = confirm("Та " + pro.name + " хөтөлбөрийг устгах уу?");
      if (result) {
        fb.db
          .collection("schools")
          .doc(this.schoolId)
          .collection("departments")
          .doc(this.departmentId)
          .collection("programs")
          .doc(pro.id)
          .delete();
      }
    },
    getPercent(data) {
      if (data) {
        var active = 0;
        var off = 0;
        if (data.numberOfArrived) active = data.numberOfArrived;
        if (data.numberOfNotArrived) off = data.numberOfNotArrived;
        var sum = active + off;
        return (active * 100) / sum;
      }
      return null;
    }
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  props: {
    schoolId: {
      required: true
    },
    sectorId: {
      required: true
    }
  },
  created() {
    var _this = this;
    if (
      this.schoolId != null &&
      this.schoolId != "" &&
      this.sectorId != null &&
      this.sectorId != ""
    )
      this._getData();
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    }
  }
};
</script>

